import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Subscription, fromEvent } from "rxjs";

@Component({
  selector: "sb-prematch-item",
  templateUrl: "./sb-prematch-item.html",
  host: {
    class: "sb-prematch-item color-dark background-color-muted",
  },
  standalone: true,
  imports: [CommonModule, FormsModule],
  styleUrls: ["./sb-prematch-item.scss"],
})
export class SbPrematchItemComponent implements AfterViewInit {
  @Input() item: any;
  @Input() imageURL: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() arrow: boolean = true;
  @Output() navigate: EventEmitter<any> = new EventEmitter();
  private _ref: HTMLElement;
  private go$: Subscription;
  name: string;
  constructor(private _element: ElementRef) {}

  ngAfterViewInit() {
    this._ref = this._element.nativeElement;

    this.go$ = fromEvent(this._ref, "click", () => {
      this.navigate.emit(this.item);
    }).subscribe();
  }

  ngOnDestroy() {
    this.go$.unsubscribe();
  }
}
